import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'
import { API_ROOT } from '@/api/config'

export default {
  getApplicationForm: function (code) {
    return Http.get({
      base_url: API_ROOT,
      url: `application/${code}/form`
    })
  },
  getApplicationFormAsCustomer: function (code) {
    return Http.get({
      url: `application/${code}/form`
    })
  },
  postApplicationFormAsGuest: function (serviceType, formAndFileData) {
    return Http.post({
      base_url: API_ROOT,
      url: `application/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  postApplicationFormAsCustomer: function (serviceType, formAndFileData) {
    return Http.post({
      url: `application/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  postInitAssently: function (serviceType, formAndFileData) {
    return Http.post({
      url: `application/init-assently/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  postValidateAssently: function (serviceType, formAndFileData, authToken, identityToken) {
    let data = Transform.createMultipartFormData(formAndFileData)
      data.append('assently_data', JSON.stringify({
        'auth_token': authToken,
        'identity_token': identityToken
      })
    )
    return Http.post({
      url: `application/validate-assently/${serviceType}`,
      data: data
    })
  },
  getAssentlyUrl: function () {
    return Http.get({
      url: `application/assently-url`
    })
  }
}
